import React from "react";
import { TimeOffStatus } from "../../utils/enums/TimeOffStatus";
import { Token } from "../../theme";

export const isPendingStatus = (status: string) => {
  const normalised = (status ?? "").replace(/_/g, " ").toUpperCase();
  return (
    normalised === TimeOffStatus.PENDING ||
    normalised === TimeOffStatus.ADD_DOCUMENTATION ||
    normalised === TimeOffStatus.PENDING_CANCELLATION
  );
};

export const statusTone = (status: string): { fg: string; bg: string } => {
  const normalised = (status ?? "").replace(/_/g, " ").toUpperCase();

  switch (normalised) {
    case TimeOffStatus.APPROVED:
      return { fg: Token.statusSuccessFg, bg: Token.statusSuccessBg };
    case TimeOffStatus.REJECTED:
      return { fg: Token.statusDangerFg, bg: Token.statusDangerBg };
    case TimeOffStatus.PENDING:
    case TimeOffStatus.PENDING_CANCELLATION:
      return { fg: Token.statusWarningFg, bg: Token.statusWarningBg };
    case TimeOffStatus.ADD_DOCUMENTATION:
      return { fg: Token.statusProgressFg, bg: Token.statusProgressBg };
    case TimeOffStatus.CANCELLED:
      return { fg: Token.textTertiary, bg: Token.surfaceSunken };
    default:
      return { fg: Token.textTertiary, bg: Token.surfaceSunken };
  }
};

const label = (status: string) => {
  const words = (status ?? "").replace(/_/g, " ").toLowerCase().trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const TimeOffStatusChip: React.FC<{ status: string }> = ({ status }) => {
  const { fg, bg } = statusTone(status);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        height: 20,
        borderRadius: 3,
        padding: "0 6px",
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
        color: fg,
        background: bg,
      }}
    >
      {label(status)}
    </span>
  );
};
